module.exports = {"TXTCLI_LoadingXX_Please_wait":{"id":"TXTCLI_LoadingXX_Please_wait","defaultMessage":"Laddar... Var god vänta"}}